var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation, useQuery } from '@apollo/client';
import { Typography } from '@mui/material';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { CONFIRM_COMMUNITY_USER_JOIN_REQUEST } from 'common/graphql/mutations/community/confirm-community-user-join-request';
import { DECLINE_COMMUNITY_USER_JOIN_REQUEST } from 'common/graphql/mutations/community/decline-community-user-join-request';
import { COMMUNITY_PARTICIPANTS_SETTINGS } from 'common/graphql/queries/community/community-participants-settings';
import { COMMUNITY_USER_JOIN_REQUESTS_SEARCH } from 'common/graphql/queries/community/community-user-join-request-search';
import { COMMUNITY_USER_JOIN_REQUESTS_COUNT } from 'common/graphql/queries/community/community-user-join-requests-count';
import { COMMUNITY_USERS_SEARCH } from 'common/graphql/queries/community/community-users-search';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/actions';
import { communityParticipantsPerPage } from '../../CommunityParticipationSettings';
import CommunityUserJoinRequestsSearchResultListItem from './CommunityUserJoinRequestsSearchResultListItem';
var CommunityUserJoinRequests = function (_a) {
    var communityId = _a.communityId;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _b = useQuery(COMMUNITY_USER_JOIN_REQUESTS_SEARCH, {
        variables: {
            communityId: communityId
        }
    }), data = _b.data, loading = _b.loading;
    var onSuccess = function (message) {
        dispatch(openSnackbar({
            message: message,
            severity: SnackbarSeverity.SUCCESS
        }));
    };
    var onError = function (_a) {
        var code = _a.code, errorDetails = _a.errorDetails;
        dispatch(openSnackbar({
            message: t(code) || errorDetails,
            severity: SnackbarSeverity.ERROR
        }));
    };
    var refetchQueries = [
        {
            query: COMMUNITY_USER_JOIN_REQUESTS_SEARCH,
            variables: {
                communityId: communityId
            }
        },
        {
            query: COMMUNITY_USER_JOIN_REQUESTS_COUNT,
            variables: {
                communityId: communityId
            }
        },
    ];
    var confirmCommunityUserJoinRequest = function (data) {
        return useMutation(CONFIRM_COMMUNITY_USER_JOIN_REQUEST, {
            variables: {
                communityId: communityId,
                userId: data
            },
            refetchQueries: refetchQueries.concat([
                {
                    query: COMMUNITY_USERS_SEARCH,
                    variables: {
                        communityId: communityId,
                        limit: communityParticipantsPerPage,
                        offset: 0,
                        searchQuery: ''
                    }
                },
                {
                    query: COMMUNITY_PARTICIPANTS_SETTINGS,
                    variables: {
                        id: communityId
                    }
                },
            ])
        });
    };
    var declineCommunityUserJoinRequest = function (data) {
        return useMutation(DECLINE_COMMUNITY_USER_JOIN_REQUEST, {
            variables: {
                communityId: communityId,
                userId: data
            },
            refetchQueries: refetchQueries
        });
    };
    var handleConfirmJoinCommunityRequest = useDynamicMutation(confirmCommunityUserJoinRequest, function () {
        onSuccess(t('Заявка принята! Пользователь добавлен в сообщество.'));
    }, onError).handleExecuteMutation;
    var handleDeclineJoinCommunityRequest = useDynamicMutation(declineCommunityUserJoinRequest, function () {
        onSuccess(t('Заявка пользователя отклонена.'));
    }, onError).handleExecuteMutation;
    if (loading)
        return _jsx(CircularProgressMui, {}, void 0);
    return (_jsxs("div", { children: [data && data.communityUserJoinRequestsSearch.length > 0 && !loading && (_jsx("div", { children: data.communityUserJoinRequestsSearch.map(function (userProfile) {
                    return (_jsx(CommunityUserJoinRequestsSearchResultListItem, { userProfile: userProfile, handleConfirmUserJoinRequest: handleConfirmJoinCommunityRequest, handleDeclineUserJoinRequest: handleDeclineJoinCommunityRequest }, void 0));
                }) }, void 0)), data && data.communityUserJoinRequestsSearch.length === 0 && !loading && (_jsx("div", __assign({ className: "flex grow justify-center" }, { children: _jsx(Typography, __assign({ sx: { fontSize: '1.8rem', fontWeight: 400 } }, { children: t('Нет активных заявок') }), void 0) }), void 0))] }, void 0));
};
export default CommunityUserJoinRequests;
